<template>
    <massive-file-loader
        :parser="parser"
        @loaded="$emit('loaded', $event)"
        @loading="$emit('loading')"
        @error="$emit('error')"
    />
</template>

<script>
import { parseFileMassiveLoadInventories } from "@/common/lib/excel";

import MassiveFileLoader from "@/components/utils/MassiveFileLoader.vue";

export default {
    name: "InventoryFileLoader",
    components: { MassiveFileLoader },
    model: {
        prop: "itemCurrent",
        event: "loaded"
    },
    emits: ["loaded", "loading", "error"],
    data: () => ({
        parser: parseFileMassiveLoadInventories
    })
};
</script>
